import { useState } from "react";
import { useTranslation } from "react-i18next";
import TnCPopup from "./TnCPopup";
import PrivacyPopup from "./PrivacyPopup";
import { Link } from "react-router-dom";
import { trackSocialLinkTap } from "../utils/ga4Events";

function Footer() {
  const { t } = useTranslation();
  const [showTncPopup, setShowTncPopup] = useState(false);
  const [showPrivacyPopup, setShowPrivacyPopup] = useState(false);

  return (
    <div className="frame-footer">
      <div className="frame-footer-pill">
        {/* Instagram */}
        <a href="https://www.instagram.com/britanniamilkbikis" target="_blank" onClick={() => trackSocialLinkTap({ platform: 'instagram', current_screen: window.location.pathname })}>
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 48 48" fill="none">
          <path d="M13.7205 0H33.5916C41.1616 0 47.3122 6.15058 47.3122 13.7205V33.5916C47.3122 37.2306 45.8666 40.7204 43.2935 43.2935C40.7204 45.8666 37.2306 47.3122 33.5916 47.3122H13.7205C6.15058 47.3122 0 41.1616 0 33.5916V13.7205C0 10.0816 1.44555 6.59175 4.01865 4.01865C6.59175 1.44555 10.0816 0 13.7205 0ZM13.2474 4.73122C10.9888 4.73122 8.82265 5.62846 7.22555 7.22555C5.62846 8.82265 4.73122 10.9888 4.73122 13.2474V34.0648C4.73122 38.7723 8.53985 42.581 13.2474 42.581H34.0648C36.3234 42.581 38.4895 41.6837 40.0866 40.0866C41.6837 38.4895 42.581 36.3234 42.581 34.0648V13.2474C42.581 8.53985 38.7723 4.73122 34.0648 4.73122H13.2474ZM36.0755 8.27963C36.8598 8.27963 37.6119 8.59117 38.1665 9.14572C38.721 9.70027 39.0325 10.4524 39.0325 11.2366C39.0325 12.0209 38.721 12.773 38.1665 13.3276C37.6119 13.8821 36.8598 14.1937 36.0755 14.1937C35.2913 14.1937 34.5392 13.8821 33.9846 13.3276C33.4301 12.773 33.1185 12.0209 33.1185 11.2366C33.1185 10.4524 33.4301 9.70027 33.9846 9.14572C34.5392 8.59117 35.2913 8.27963 36.0755 8.27963ZM23.6561 11.828C26.7931 11.828 29.8016 13.0742 32.0198 15.2924C34.238 17.5106 35.4841 20.5191 35.4841 23.6561C35.4841 26.7931 34.238 29.8016 32.0198 32.0198C29.8016 34.238 26.7931 35.4841 23.6561 35.4841C20.5191 35.4841 17.5106 34.238 15.2924 32.0198C13.0742 29.8016 11.828 26.7931 11.828 23.6561C11.828 20.5191 13.0742 17.5106 15.2924 15.2924C17.5106 13.0742 20.5191 11.828 23.6561 11.828ZM23.6561 16.5593C21.7739 16.5593 19.9688 17.307 18.6379 18.6379C17.307 19.9688 16.5593 21.7739 16.5593 23.6561C16.5593 25.5383 17.307 27.3434 18.6379 28.6743C19.9688 30.0052 21.7739 30.7529 23.6561 30.7529C25.5383 30.7529 27.3434 30.0052 28.6743 28.6743C30.0052 27.3434 30.7529 25.5383 30.7529 23.6561C30.7529 21.7739 30.0052 19.9688 28.6743 18.6379C27.3434 17.307 25.5383 16.5593 23.6561 16.5593Z" fill="black" />
        </svg>
        </a>
        {/* X */}
        <a href="https://x.com/MilkBikisIndia" target="_blank" onClick={() => trackSocialLinkTap({ platform: 'x', current_screen: window.location.pathname })}>
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={43} viewBox="0 0 48 43" fill="none">
          <path d="M37.2603 0H44.5148L28.6653 18.1166L47.3122 42.7643H32.7124L21.2786 27.8136L8.19289 42.7643H0.934415L17.8879 23.386L0 0.00197143H14.9704L25.3061 13.6673L37.2603 0ZM34.7153 38.4234H38.7349L12.7861 4.11419H8.47282L34.7153 38.4234Z" fill="black" />
        </svg>
        </a>
        {/* Facebook */}
        <a href="https://www.facebook.com/MilkBikis" target="_blank" onClick={() => trackSocialLinkTap({ platform: 'facebook', current_screen: window.location.pathname })}>
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={47} viewBox="0 0 48 47" fill="none">
          <path d="M47.3122 23.3666C47.3122 10.4682 36.7142 0 23.6561 0C10.5979 0 0 10.4682 0 23.3666C0 34.6761 8.13769 44.0928 18.9249 46.2659V30.3766H14.1937V23.3666H18.9249V17.525C18.9249 13.0152 22.6389 9.34665 27.2045 9.34665H33.1185V16.3566H28.3873C27.0862 16.3566 26.0217 17.4081 26.0217 18.6933V23.3666H33.1185V30.3766H26.0217V46.6164C37.968 45.4481 47.3122 35.4939 47.3122 23.3666Z" fill="black" />
        </svg>
        </a>
      </div>
      <p className="frame-footer-terms">
        <Link
          to="/term-and-condition"
          onClick={(e) => {
            e.preventDefault();
            setShowTncPopup(true);
          }}
        >
          {t("common.terms")}
        </Link>{" "}
        {t("common.and")}{" "}
        <Link
          to="/privacy-policy"
          onClick={(e) => {
            e.preventDefault();
            setShowPrivacyPopup(true);
          }}
        >
          {t("common.privacy")}
        </Link>
      </p>
      <TnCPopup
        isOpen={showTncPopup}
        onClose={() => setShowTncPopup(false)}
        showCloseButton={true}
      />
      <PrivacyPopup
        isOpen={showPrivacyPopup}
        onClose={() => setShowPrivacyPopup(false)}
        showCloseButton={true}
      />
    </div>
  )
}

export default Footer
